import Link from 'next/link'
import VStack from '@/components/core/VStack/VStack'
import HStack from '@/components/core/HStack/HStack'
import { SOCIAL_MEDIA } from '@/constants/social-media'

export type FooterProps = {}

export default function Footer(props: FooterProps) {
    return (
        <footer className='w-full mt-16 bg-background border-t border-border'>
            <div className='@min-xs:max-w-[1348px] mx-auto py-12'>
                <HStack className='gap-8 items-center justify-center'>

                    {/* Powered by Chainlink */}
                    <VStack className='gap-0 items-center'>
                        <span className='text-xs text-secondary-foreground'>Powered by</span>
                        <img 
                            src='/chainlink-logo.svg' 
                            alt='Chainlink' 
                            className="w-[86px] h-[26px]"
                        />
                    </VStack>

                    {/* Logo */}
                    <HStack className='gap-2 items-baseline'>
                        <img 
                            src='/assets/svgs/logo-with-text.svg' 
                            alt='BlockPot Logo' 
                            className="w-[160px] h-10"
                        />
                    </HStack>
                    
                    {/* Navigation Links */}
                    <HStack className='gap-6'>
                        <Link 
                            href='/transparency' 
                            className='text-sm text-secondary-foreground hover:text-foreground transition-colors'
                        >
                            Transparency
                        </Link>
                    </HStack>
                </HStack>
                <div className="flex gap-6 pt-8 pb-4 justify-center">
                    {
                        SOCIAL_MEDIA.map((social) => (
                            <a href={social.url} target="_blank" rel="noopener noreferrer" className='cursor-pointer hover:opacity-80 hover:scale-95 transition-all' key={social.name}>
                                <img src={social.src} alt={social.name} width={20} height={20} />
                            </a>
                        ))
                    }
                </div>
            </div>
        </footer>
    )
}